// extracted by mini-css-extract-plugin
export default {"privacy":"Privacy_privacy__tyGi2","privacy_subtitles":"Privacy_privacy_subtitles__FFVx2"};